import { useState, useEffect, useCallback } from "react";
import { MODULE_API } from "../../../../apis";
const ParentModules = [
  "Personal and Family Information",
  "Emergency Contacts",
  "Property Documentation",
  "Financial Documentation",
  "Important Documents Storage",
  "Emergency Supplies Inventory",
  "Evacuation Planning",
  "Home Safety And Security",
  "Communication Plan",
  "Insurance Coverage",
  "Recovery Plan",
];
const formatModuleKey = (moduleName) => {
  return (
    moduleName &&
    moduleName
      .replace(/[^a-zA-Z ]/g, "")
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
        index === 0 ? word.toLowerCase() : word.toUpperCase()
      )
      .replace(/\s+/g, "") + "Data"
  );
};

const useModuleData = (moduleNames = {}, setLoading) => {
  const [disasterAttributeData, setDisasterAttributeData] = useState(null);
  const [toUpdate, setToUpdate] = useState(false);
  const [errorState, setError] = useState(null);
  const [tableData, setTableData] = useState(() => {
    return moduleNames.reduce((acc, name) => {
      acc[formatModuleKey(name)] = [];
      return acc;
    }, {});
  });

  const fetchData = useCallback(async (moduleName) => {
    try {
      setLoading(true);
      console.log(`Fetching data for module: ${moduleName}`); // Debugging log
      const res = await MODULE_API.fetchItems({
        moduleName,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      console.log("Fetched Data:", res.records);
      const disasterData =
        res &&
        res.records.find((record) => ParentModules.includes(record.module) || record.subType === "Disaster");
      if (disasterData) {
        console.log("disasterData", disasterData);
        setDisasterAttributeData(disasterData);
      }
      setLoading(false);
      return { moduleName, records: res.records || [] };
    } catch (err) {
      console.error(`Error fetching ${moduleName}:`, err);
      return { moduleName, records: [] };
    }
  }, []);
  const fetchAllModulesData = async () => {
    setError(null);
    try {
      setLoading(true);
      const results = await Promise.all(moduleNames.map(async (name) => await fetchData(name)));
      console.log("resultss", results);

      const formattedData = results.reduce((acc, { moduleName, records }) => {
        acc[formatModuleKey(moduleName)] = records;
        return acc;
      }, {});

      setTableData(formattedData);
    } catch (err) {
      setError(err);
      console.error("Error fetching modules:", err);
    } finally {
      setLoading(false);
    }
  };

  // Optionally fetch data automatically when moduleNames change
  useEffect(() => {
    if (moduleNames && moduleNames.length > 0) {
      fetchAllModulesData();
    }
  }, []);
  useEffect(() => {
    if (disasterAttributeData && disasterAttributeData.id) {
      setToUpdate(true);
    }
  }, [disasterAttributeData]);

  return {
    errorState,
    toUpdate,
    disasterAttributeData,
    setToUpdate,
    formatModuleKey,
    fetchData,
    tableData,
    setTableData,
  };
};

export default useModuleData;
